export const DEFAULT_VALUES = {
  lastName: '',
  firstName: '',
  middleNameField: {
    middleName: '',
    doesntExist: false,
  },
  birthDate: '',
  birthPlace: '',
  documentType: 'Паспорт',
  documentSerial: '',
  documentNumber: '',
  documentIssuedBy: '',
  documentIssueDate: '',
  addressReg: '',
  addressFactField: {
    addressFact: '',
    same: false,
  },
  INN: '',
  phoneMobile: '',
  personalDataConsent: false,
  isGosuslugi: false,
};
